<div class="col-12" id="account">
    <div class="col-12">
        <h2 class="page-title" tabindex="0">{{'account.subscription_purchase' | translate}}</h2>
        <ngx-spinner bdColor="rgba(51,51,51,0.55)"
            size="medium"
            color="#fff"
            type="line-spin-clockwise-fade"
            [fullScreen]="false">
            <p class="loading">{{ 'general.loading' | translate }}...</p>
        </ngx-spinner>
        <xng-breadcrumb separator=" > ">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
                <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
            </ng-container>
        </xng-breadcrumb>
        <div *ngIf="cart!=null">
            <form class="w-100" [formGroup]="buySubscriptionForm" name="form" (ngSubmit)="buySubscription()">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 p-2">
                        <div class="card border-top">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-2 d-none d-sm-block">
                                        <img class="rounded" src="assets/images/sa-icon.png" alt="{{'alt.sa_logo' | translate}}">
                                    </div> 
                                    <div class="col-xs-12 col-sm-10">
                                        <div id="server_error" class="error text-center"></div>
                                        <h4>Panic Alert - 
                                            <span class="text-nowrap">{{cart["planName"] | translate}}</span>&nbsp;&nbsp;
                                            <a class="custom-hyperlink" (click)="changePlan()">{{'account.change_plan' | translate}}</a>
                                        </h4>
                                        <div>
                                            {{cart.planDescription}}
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "roles.agents_supervisors" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ cart?.planAgentsSupervisors }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "roles.users" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ cart?.planUsers }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "plan.video_feature" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ (cart?.planIncludesVideo?'general.yes':'No') | translate }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "plan.agent_dispatch" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ (cart?.planAgentDispatch?'general.yes':'No') | translate }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "plan.geo_zone_assignment" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ (cart?.planGeoAssignment?'general.yes':'No') | translate }}</p>
                                            </div>
                                        </div>
                                        <div class="small">
                                            {{'account.renew_details' | translate}}
                                        </div>
                                        <hr>
                                        <strong>{{'account.billing_cycle' | translate}}<span class="error">*</span>: </strong>
                                        <label class="radio-inline pt-0 pl-1 pb-0 pr-1">
                                            <input type="radio" name="BillingCycle" formControlName="BillingCycle" value="M" (click)="getBillingQuantity('M')" [(ngModel)]="model.options">&nbsp;{{'account.monthly' | translate}}
                                        </label>
                                        <label class="radio-inline pt-0 pl-1 pb-0 pr-1">
                                            <input type="radio" name="BillingCycle" formControlName="BillingCycle" value="Y" (click)="getBillingQuantity('Y')" [(ngModel)]="model.options" >&nbsp;{{'account.yearly' | translate}}
                                        </label><br>
                                        <div class="col-12 p-0" *ngIf="cardInfo!=null">
                                            <strong>{{'account.payment_information' | translate}}:</strong><br>
                                            <div class="card w-75">
                                                <div class="card-body">
                                                    <div>
                                                        <div class="row text-left">
                                                            <div class="col-12 text-right h4"><i [class]="cardInfo['card-fa']"></i></div>
                                                            <div class="col-12">**** **** **** {{cardInfo.cardLast4Digits}}</div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-8 text-left">{{cardInfo.cardName}}</div>
                                                            <div class="col-4 text-right">{{cardInfo.cardExpirationMonth}}/{{cardInfo.cardExpirationYear}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="w-75">
                                                <strong>{{'account.billing_address' | translate}}:</strong><br>
                                                {{cardInfo.billingAddress1}}<br>
                                                {{cardInfo.billingCity}}<br>
                                                {{cardInfo.billingState}}, {{cardInfo.billingCountry}}, {{cardInfo.billingZipCode}}
                                            </div>
                                            <div class="w-75 text-right custom-hyperlink"><a routerLink="payment-methods" routerLinkActive="active"><i class="fa fa-pencil"></i>{{'account.change_payment_method' | translate}}</a></div>
                                        </div>
                                        <div *ngIf="cardInfo==null">
                                            <div class="row">
                                                <div class="col-xs-12 col-sm-6">
                                                    <label class="mb-0">{{'account.card_name' | translate}}<span class="error">*</span></label>
                                                    <input type="text" formControlName="CardName" class="form-control" maxlength="26" 
                                                    [ngClass]="{ 'is-valid': CardName['valid'], 'is-invalid': CardName['invalid'] }"/>
                                                    <ng-container *ngIf="buySubscriptionForm.get('CardName').invalid && (buySubscriptionForm.get('CardName').touched || buySubscriptionForm.get('CardName').dirty)">
                                                        <div *ngIf="buySubscriptionForm.get('CardName').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="buySubscriptionForm.get('CardName').hasError('pattern')" class="error">
                                                            {{'error.card_name' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <label class="top-bottom">{{'account.card_number' | translate}}<span class="error">*</span></label>
                                                    <ngx-stripe-card #card [options]="cardOptions" [elementsOptions]="elementsOptions" (change)="cardUpdated($event)" (error)="error = $event"></ngx-stripe-card>
                                                    <div class="error">
                                                    {{error?.message}}
                                                    </div>
                                                    <br>
                                                </div>
                                            </div>
                                            <hr class="mt-2">
                                            <strong>{{'account.billing_address' | translate}}: </strong><br><br>
                                            <div class="row">
                                                <div class="col-12">
                                                    <label class="mb-0">{{'user.address' | translate}}<span class="error">*</span></label>
                                                    <input type="text" formControlName="BillingAddress" class="form-control" 
                                                    [ngClass]="{ 'is-valid': BillingAddress['valid'], 'is-invalid': BillingAddress['invalid'] }"/>
                                                    <ng-container *ngIf="buySubscriptionForm.get('BillingAddress').invalid && (buySubscriptionForm.get('BillingAddress').touched || buySubscriptionForm.get('BillingAddress').dirty)">
                                                        <div *ngIf="buySubscriptionForm.get('BillingAddress').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="buySubscriptionForm.get('BillingAddress').hasError('pattern')" class="error">
                                                            {{'error.address' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <label class="top-bottom">{{'user.city' | translate}}<span class="error">*</span></label>
                                                    <input type="text" formControlName="BillingCity" class="form-control"
                                                    [ngClass]="{ 'is-valid': BillingCity['valid'], 'is-invalid': BillingCity['invalid'] }"/>
                                                    <ng-container *ngIf="buySubscriptionForm.get('BillingCity').invalid && (buySubscriptionForm.get('BillingCity').touched || buySubscriptionForm.get('BillingCity').dirty)">
                                                        <div *ngIf="buySubscriptionForm.get('BillingCity').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="buySubscriptionForm.get('BillingCity').hasError('pattern')" class="error">
                                                            {{'error.address' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="col-6">
                                                    <label class="top-bottom">{{'user.state' | translate}}<span class="error">*</span></label>
                                                    <input type="text" formControlName="BillingState" class="form-control"
                                                    [ngClass]="{ 'is-valid': BillingState['valid'], 'is-invalid': BillingState['invalid'] }"/>
                                                    <ng-container *ngIf="buySubscriptionForm.get('BillingState').invalid && (buySubscriptionForm.get('BillingState').touched || buySubscriptionForm.get('BillingState').dirty)">
                                                        <div *ngIf="buySubscriptionForm.get('BillingState').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="buySubscriptionForm.get('BillingState').hasError('pattern')" class="error">
                                                            {{'error.address' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <label class="top-bottom">{{'user.country' | translate}}<span class="error">*</span></label>
                                                    <input type="text" formControlName="BillingCountry" id= "BillingCountry" class="form-control" 
                                                    [ngClass]="{ 'is-valid': BillingCountry['valid'], 'is-invalid': BillingCountry['invalid'] }" />
                                                    <ng-container *ngIf="buySubscriptionForm.get('BillingCountry').invalid && (buySubscriptionForm.get('BillingCountry').touched || buySubscriptionForm.get('BillingCountry').dirty)">
                                                        <div *ngIf="buySubscriptionForm.get('BillingCountry').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="buySubscriptionForm.get('BillingCountry').hasError('pattern')" class="error">
                                                            {{'error.address' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>             
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 p-2">
                        <div class="card border-top-green">
                            <div class="card-body">
                                <h4>{{'account.order_summary' | translate}}</h4>
                                <hr>
                                <h5>
                                    <div class="row">
                                        <div class="col-xs-12 col-md-6">Subtotal: </div>
                                        <div class="col-xs-12 col-md-6 text-right">${{(subtotal)?(functionsService.currencyFormat(subtotal)):''}} USD</div>
                                    </div>
                                    <div id="tax-row" class="row tax-row">
                                        <div class="col-xs-12 col-md-6">Tax (11.5%): </div>
                                        <div class="col-xs-12 col-md-6 text-right">${{tax?functionsService.currencyFormat(tax):" "}} USD</div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-xs-12 col-md-3">Total: </div>
                                        <div class="col-xs-12 col-md-9 text-right"><h3>${{(total)?(functionsService.currencyFormat(total)):''}} USD</h3> <i> {{'account.'+ MorY | translate}}</i></div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <input type="submit" class="btn btn-green btn-h-green w-100 ml-2 mr-2" title="{{'account.complete_order' | translate}}" 
                                            value="{{'account.complete_order' | translate}}">
                                    </div>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div *ngIf="cart==null">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 p-2">
                    <div class="card border-top">
                        <div class="card-body">
                            <h4>{{'account.account_information' | translate}}</h4>
                            <hr>
                            <div class="row">
                                <div class="col-12 profile-pic text-center">
                                    <img class="img-round" [src]="orgProfile?.logo?orgProfile.logo:'assets/images/company.png'" width="120" height="120" alt="{{orgProfile?.name}}" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <strong>{{orgProfile?.name}}</strong>
                                </div>
                            </div>
                            <div class="row pt-10">
                                <div class="col-6">
                                    <i class="fa fa-user"></i>&nbsp;<strong>{{'account.owner' | translate}}:</strong>
                                </div>
                                <div class="col-6">
                                    {{orgProfile?.profileFirstName}} {{orgProfile?.profileLastName}}
                                </div>
                            </div>
                            <div class="row pt-10">
                                <div class="col-6">
                                    <i class="fa fa-envelope"></i>&nbsp;<strong>{{'general.email' | translate}}:</strong>
                                </div>
                                <div class="col-6">
                                    {{email}}
                                </div>
                            </div>
                            <div class="row pt-10">
                                <div class="col-6">
                                    <i class="fa fa-phone"></i>&nbsp;<strong>{{'account.owner_phone' | translate}}:</strong>
                                </div>
                                <div class="col-6">
                                    {{orgProfile?.profilePhoneNumber}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 p-2">
                    <div class="card border-top">
                        <div class="card-body">
                            <h4>{{'subscription.subscription' | translate}}</h4>
                            <hr>
                            <div class="row">
                                <div class="col-12 pl-2 font-weight-lighter h3">
                                    {{'account.invalid_subscription' | translate}} <a class="hyperlink" (click)="changePlan()">{{'account.here' | translate}}</a>.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
